import { createFileRoute } from '@tanstack/react-router';

import ScorecardWatchlistPage from '../../views/dashboard-scorecard-watchlist';

export const Route = createFileRoute('/dashboard/scorecard/watchlist')({
  component: ScorecardWatchlistPage,
});
